import { render, staticRenderFns } from "./ContentNotFound.vue?vue&type=template&id=cf69674c"
import script from "./ContentNotFound.vue?vue&type=script&lang=js"
export * from "./ContentNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports